// ==========================================================================
// components/NumberPad.tsx — big, thumb-friendly number entry (FF-008)
// On the phone the field itself opens the numeric keyboard (inputMode).
// The on-screen pad below it works everywhere, including desktop with a
// mouse, and is what James asked for: "number pads when numerical entries".
// ==========================================================================
import { Delete } from "lucide-react";

export function KmField({ label, value, onChange, hint, autoFocus }: { label: string; value: string; onChange: (v: string) => void; hint?: string; autoFocus?: boolean }) {
  return (
    <label className="block">
      <span className="text-sm font-medium text-ink-muted">{label}</span>
      <div className="mt-1 flex items-baseline gap-2 rounded-md border border-line bg-bg px-3 py-2 focus-within:border-primary">
        <input
          inputMode="numeric" pattern="[0-9]*" autoFocus={autoFocus}
          value={value} onChange={(e) => onChange(e.target.value.replace(/\D/g, "").slice(0, 7))}
          className="num w-full bg-transparent text-3xl font-semibold text-ink outline-none"
          placeholder="0"
        />
        <span className="text-ink-muted">km</span>
      </div>
      {hint && <span className="mt-1 block text-xs text-ink-muted">{hint}</span>}
    </label>
  );
}

export function NumberPad({ onKey }: { onKey: (k: string) => void }) {
  const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "00", "0", "⌫"];
  return (
    <div className="grid grid-cols-3 gap-2">
      {keys.map((k) => (
        <button key={k} type="button" onClick={() => onKey(k)}
          className="num flex h-14 items-center justify-center rounded-md bg-surface-raised text-2xl font-semibold text-ink active:bg-primary/15">
          {k === "⌫" ? <Delete className="h-6 w-6" /> : k}
        </button>
      ))}
    </div>
  );
}

/** Apply a pad key to a digit string. */
export function applyKey(v: string, k: string): string {
  if (k === "⌫") return v.slice(0, -1);
  return (v + k).replace(/^0+(?=\d)/, "").slice(0, 7);
}
